import { render, staticRenderFns } from "./SemApps.vue?vue&type=template&id=fcbc28e4&"
import script from "./SemApps.vue?vue&type=script&lang=js&"
export * from "./SemApps.vue?vue&type=script&lang=js&"
import style0 from "./SemApps.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/common/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fviews%2FSemApps.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports